import { render, staticRenderFns } from "./centerVideo2.vue?vue&type=template&id=df6a5ea4&scoped=true&"
import script from "./centerVideo2.vue?vue&type=script&lang=js&"
export * from "./centerVideo2.vue?vue&type=script&lang=js&"
import style0 from "./centerVideo2.vue?vue&type=style&index=0&id=df6a5ea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df6a5ea4",
  null
  
)

export default component.exports